import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Divider, Grid } from 'semantic-ui-react';
import shortid from 'short-id';
import _ from 'lodash';
import moment from 'moment';

import { getAccounts } from '../../services/AccountService';
import ProgressQCRow from './ProgressQCRow';
import { getUserPreferences } from '../../services/UserPreferencesManager';
import CountDown from './CountDown';

class QCSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refProgress: [],
      hasUserPref: false,
      userPref: {},
      token: props.getFbToken(),
      accounts: [],
      countDown: moment().add(10, 'minutes')
    };
  }
  componentDidMount() {
    const { setSectionTitle } = this.props;
    if (setSectionTitle) setSectionTitle('QC Summary');
    this.getAdAccounts().then(() => {
      this.checkUserPreferences().then(() => {
        this.setupAutoRefresh();
      });
    });
  }
  getAdAccounts = async () => {
    try {
      const result = await getAccounts();

      const accountOptions = _.sortBy(
        _.map(result, (op, index) => ({
          key: index,
          value: op.account_id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        accountOptions,
        accounts: _.sortBy([...result], 'name')
      });
    } catch (error) {
      console.log(error);
    }
  };
  setupAutoRefresh = () => {
    if (this.state.intervalId !== -1) {
      clearInterval(this.state.intervalId);
    }
    const intervalId = setInterval(() => {
      this.refreshAll(this.state.refProgress);
      this.setState({ countDown: moment().add(10, 'minutes') });
    }, 600000);
    this.setState({
      intervalId
    });
  };
  checkUserPreferences = async () => {
    const userPref = await getUserPreferences(this.props.user.email);
    this.setState({
      userPref: userPref.user,
      hasUserPref: userPref && userPref.user && userPref.user !== null
    });
  };
  refreshAll = (refProgress) => {
    this.setState({ countDown: moment().add(10, 'minutes') });
    refProgress.forEach((n) => {
      if (n !== null && n.refreshAll) {
        n.refreshAll();
      }
    });
  };
  render() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Button
              onClick={() => {
                this.refreshAll(this.state.refProgress);
              }}
            >
              Refresh All
            </Button>{' '}
            <CountDown date={this.state.countDown.toDate()} />
            <Divider />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            <ProgressQCRow
              index={1}
              user={this.props.user}
              accounts={this.state.accounts}
              accountOptions={this.state.accountOptions}
              userPref={this.state.userPref}
              ref={(node) => this.state.refProgress.push(node)}
              key={shortid.generate()}
              getFbToken={this.props.getFbToken}
            />
            <Divider />
          </Grid.Column>
          <Grid.Column width={16}>
            <ProgressQCRow
              index={2}
              user={this.props.user}
              accounts={this.state.accounts}
              accountOptions={this.state.accountOptions}
              userPref={this.state.userPref}
              ref={(node) => this.state.refProgress.push(node)}
              key={shortid.generate()}
              getFbToken={this.props.getFbToken}
            />
            <Divider />
          </Grid.Column>
          <Grid.Column width={16}>
            <ProgressQCRow
              index={3}
              user={this.props.user}
              accounts={this.state.accounts}
              accountOptions={this.state.accountOptions}
              userPref={this.state.userPref}
              ref={(node) => this.state.refProgress.push(node)}
              key={shortid.generate()}
              getFbToken={this.props.getFbToken}
            />
            <Divider />
          </Grid.Column>
          <Grid.Column width={16}>
            <ProgressQCRow
              index={4}
              user={this.props.user}
              accounts={this.state.accounts}
              accountOptions={this.state.accountOptions}
              userPref={this.state.userPref}
              ref={(node) => this.state.refProgress.push(node)}
              key={shortid.generate()}
              getFbToken={this.props.getFbToken}
            />
            <Divider />
          </Grid.Column>
          <Grid.Column width={16}>
            <ProgressQCRow
              index={5}
              user={this.props.user}
              accounts={this.state.accounts}
              accountOptions={this.state.accountOptions}
              userPref={this.state.userPref}
              ref={(node) => this.state.refProgress.push(node)}
              key={shortid.generate()}
              getFbToken={this.props.getFbToken}
            />
            <Divider />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(QCSummary);



// WEBPACK FOOTER //
// ./src/screens/QCSummary/QCSummary.js